import l, { validateMetadata as h } from "./metadata.js";
import d from "./isPossible.js";
import v from "./isValid.js";
import w from "./helpers/getNumberType.js";
import P from "./helpers/getPossibleCountriesForNumber.js";
import C from "./helpers/extractCountryCallingCode.js";
import s from "./helpers/isObject.js";
import E from "./format.js";
function o(r) {
  "@babel/helpers - typeof";

  return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o(r);
}
function f(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function (i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function c(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f(Object(e), !0).forEach(function (n) {
      j(r, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : f(Object(e)).forEach(function (n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return r;
}
function j(r, t, e) {
  return (t = y(t)) in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function O(r, t) {
  if (!(r instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function k(r, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, y(n.key), n);
  }
}
function N(r, t, e) {
  return t && k(r.prototype, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function y(r) {
  var t = T(r, "string");
  return o(t) == "symbol" ? t : t + "";
}
function T(r, t) {
  if (o(r) != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t);
    if (o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var U = function () {
    function r(t, e, n) {
      if (O(this, r), !t) throw new TypeError("First argument is required");
      if (typeof t != "string") throw new TypeError("First argument must be a string");
      if (t[0] === "+" && !e) throw new TypeError("`metadata` argument not passed");
      if (s(e) && s(e.countries)) {
        n = e;
        var i = t;
        if (!_.test(i)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var u = C(i, void 0, void 0, n),
          m = u.countryCallingCode,
          p = u.number;
        if (e = p, t = m, !e) throw new Error("Invalid `number` argument passed: too short");
      }
      if (!e) throw new TypeError("`nationalNumber` argument is required");
      if (typeof e != "string") throw new TypeError("`nationalNumber` argument must be a string");
      h(n);
      var a = S(t, n),
        b = a.country,
        g = a.countryCallingCode;
      this.country = b, this.countryCallingCode = g, this.nationalNumber = e, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function () {
        return n;
      };
    }
    return N(r, [{
      key: "setExt",
      value: function value(e) {
        this.ext = e;
      }
    }, {
      key: "getPossibleCountries",
      value: function value() {
        return this.country ? [this.country] : P(this.countryCallingCode, this.nationalNumber, this.getMetadata());
      }
    }, {
      key: "isPossible",
      value: function value() {
        return d(this, {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "isValid",
      value: function value() {
        return v(this, {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "isNonGeographic",
      value: function value() {
        var e = new l(this.getMetadata());
        return e.isNonGeographicCallingCode(this.countryCallingCode);
      }
    }, {
      key: "isEqual",
      value: function value(e) {
        return this.number === e.number && this.ext === e.ext;
      }
    }, {
      key: "getType",
      value: function value() {
        return w(this, {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "format",
      value: function value(e, n) {
        return E(this, e, n ? c(c({}, n), {}, {
          v2: !0
        }) : {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "formatNational",
      value: function value(e) {
        return this.format("NATIONAL", e);
      }
    }, {
      key: "formatInternational",
      value: function value(e) {
        return this.format("INTERNATIONAL", e);
      }
    }, {
      key: "getURI",
      value: function value(e) {
        return this.format("RFC3966", e);
      }
    }]);
  }(),
  M = function M(t) {
    return /^[A-Z]{2}$/.test(t);
  };
function S(r, t) {
  var e,
    n,
    i = new l(t);
  return M(r) ? (e = r, i.selectNumberingPlan(e), n = i.countryCallingCode()) : n = r, {
    country: e,
    countryCallingCode: n
  };
}
var _ = /^\+\d+$/;
export { U as default };